import { httpAction, getAction} from '@/api/manage'
import {ajaxGetDictItems,getDictItemsFromCache} from '@/api/api'
import eventBus from '@/utils/eventBus'
export const PlatformModelInfoMixins = {
  data () {
    return {
      disableSubmit:true,
      width:1080,
      confirmLoading:true,
      dmPlatformId:null,
      visible:false,
      contentHeight:826,
      leftMap:{
        leftTab:0
      },
      dictOptions:{},
      ptModel:{
        driverId:""
      },
      hasChangeFlag:false,
      tabList:[
        {
          tab:1,
          title:'基本信息'
        },
        {
          tab:2,
          title:'月数据（GMV）'
        }
      ]
    }
  },
  methods: {
    addPlatform(driverId){
      console.log(driverId)
      this.leftMap = {
        leftTab:1
      }
      this.visible = true;
      this.clear();
      this. edit({
        driverId:driverId
      })
      this.disableSubmit = false;
      this.confirmLoading = false;
    },
    edit(record){
      console.log(record)
      this.ptModel = record;
      this.hasChangeFlag = false;
      this.$nextTick(()=>{
        //this.$refs.platformInfo.edit();
        if(this.leftMap.leftTab==1){
          this.hasChangeFlag = false;
          this.$refs.realForm.edit(this.ptModel);
        }
        //this.$refs.platformInfoTable.init();
      })
    },
    async  showInfo(dmPlatformId){
      this.visible = true;
      this.dmPlatformId = dmPlatformId;
      this.leftMap = {
        leftTab:1
      }
      await this.loadConfig(1)
      this.confirmLoading = false;
    },clear(){
      this.ptModel = {};
      this.dmPlatformId = null;
    },changeTab(leftMap){
      if(leftMap.leftTab!=1 && this.hasChangeFlag){
        this.checkPtInfo(this.savePtInfo,null,this.changeTabSure,leftMap);
      }else{
        this.changeTabSure(leftMap)
      }
    },changeTabSure(leftMap){
      this.leftMap = leftMap;
      this.loadConfig();
    },async loadConfig(t){
      this.disableSubmit = true;
      if(t){
        this.getInfo()
      }else{
        this.getPtInfo();
      }

    },checkPtInfo(back,backParam,close,closeParam){
      this.$confirm({
        title: '提示',
        okText: '确认',
        cancelText: '取消',
        content: '信息已修改，是否保存？',
        onOk: () => {
          if(back){
            back(backParam);
          }
        },
        onCancel: () => {
          if(close){
            close(closeParam)
          }
        }
      })
    },getPtInfo(t){
      if(this.dmPlatformId && (!this.ptModel || Object.keys(this.ptModel).length==0)){
        if(!t){
          this.getInfo();
        }
      }else{
        if(this.leftMap.leftTab==1){
          this.$nextTick(()=>{
            this.$refs.realForm.edit(this.ptModel);
          })
        }
        else if(this.leftMap.leftTab==2){
          this.$nextTick(()=>{
            this.$refs.gmvTable.loadList();
          })
        }
        else{
          this.$nextTick(()=>{
            this.$refs.platformDriverTable.loadList();
          })

        }
      }
      if(t){
        this.getInfo();
      }
      this.hasChangeFlag = false;
    },handleOk(){

    },callbackOk(){
      this.loadConfig(1);
    },handleCancel(){
      if(this.leftMap.leftTab==1 && this.hasChangeFlag){
        this.checkPtInfo(this.savePtInfo,null,this.closeTab,null);
      }else{
        this.closeTab()
      }
      this.$emit("ok");
    },closeTab(){
      this.visible = false;
      this.$emit("ok")
    },
    getInfo(ptId) {
      this.visible = true;
      if(ptId){
        this.dmPlatformId = ptId
      }
      this.confirmLoading = true
      let params = {id: this.dmPlatformId};
      getAction("/dm/dmDriverPlatform/queryById", params).then((res) => {
        if (res.success) {
          if(this.ptModel.driverId){
            this.ptModel = {
              driverId:this.ptModel.driverId
            };
          }else{
            this.ptModel = {};
          }
          this.disableSubmit = true;
          this.edit(res.result);
          this.confirmLoading = false
        }
      })

    },getData(formData){
      let that = this;
      that.confirmLoading = true;
      let httpurl = '';
      let method = '';
      if(!formData.id){
        httpurl+="/dm/dmDriverPlatform/add";
        method = 'post';
      }else{
        httpurl+="/dm/dmDriverPlatform/edit";
        method = 'put';
      }
      that.loading = true
      httpAction(httpurl,formData,method).then((res)=>{
        if(res.success){
          that.$message.success("保存成功!");
          that.$emit('ok');
          that.disableSubmit = true;
          that.dmPlatformId = res.result.id;
          // 喜报触发：仅新增挂靠或更换所属队长时发（编辑且队长未变不发）
          // 保存接口返回值字段不全，统一再查一次详情补全队长名/平台名
          const isNew = !formData.id
          const leaderChanged = !isNew && formData.leaderId !== this.ptModel.leaderId
          if (isNew || leaderChanged) {
            getAction("/dm/dmDriverPlatform/queryById", { id: res.result.id }).then((r) => {
              if (r.success && r.result && r.result.leaderId && r.result.realname && r.result.platformName) {
                eventBus.$emit('push-notify', '恭喜 ' + r.result.realname + ' 增加一名 ' + r.result.platformName + ' 队员！！！')
                console.log('[喜报触发]', r.result.realname, r.result.platformName)
              } else {
                console.warn('[喜报触发] 详情字段不全，未触发', r.result)
              }
            })
          } else {
            console.log('[喜报] 未更换队长或非新增，不触发，formData.id=', formData.id, 'formData.leaderId=', formData.leaderId, 'ptModel.leaderId=', this.ptModel.leaderId)
          }
          this.edit(res.result);
        }else{
          that.$message.warning(res.message);
        }
      }).finally(() => {
        that.loading = false;
        that.confirmLoading = false;
      })

    },savePtInfo(){
      if(this.leftMap.leftTab==1){
        this.$refs.realForm.submitForm();
      }else{
        this.getData(this.ptModel);
      }

    },hasChange(){
      this.hasChangeFlag = true;
    },cancelPt(){
      this.disableSubmit = true;
      this.loadConfig(1);
    }
  }
}